module.exports = __webpack_public_path__ + "static/nosBG-e435f2d7c9321ae7fcdcaa6c895ccbcb.jpg";